import {cpd, dmt} from '../../api-sdk';

export default {
  install(app) {    
    app.config.globalProperties.$api = cpd;
    app.config.globalProperties.$dmt = dmt;
  }
};
